export function isRedFob({ text, parentId }) {
  return !parentId && /\b(sale)\b/i.test(text);
}
